import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../ui/table';
import { Card, CardContent } from '../../ui/card';
import DocumentValidationWorkflowTableRow from './DocumentValidationWorkflowTableRow';
import type { Document } from '../../../api/documentApi';

interface DocumentValidationWorkflowTableProps {
  documents: Document[];
  statusColors: Record<string, string>;
  onReview: (document: Document) => void;
  type: 'pending' | 'approved' | 'rejected';
}

export default function DocumentValidationWorkflowTable({
  documents,
  statusColors,
  onReview,
  type,
}: DocumentValidationWorkflowTableProps) {
  const getTableHeaders = () => {
    switch (type) {
      case 'pending':
        return (
          <>
            <TableHead>Dokumen</TableHead>
            <TableHead>Entitas</TableHead>
            <TableHead>Modul</TableHead>
            <TableHead>Upload</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Aksi</TableHead>
          </>
        );
      case 'approved':
        return (
          <>
            <TableHead>Dokumen</TableHead>
            <TableHead>Entitas</TableHead>
            <TableHead>Validator</TableHead>
            <TableHead>Tanggal</TableHead>
          </>
        );
      case 'rejected':
        return (
          <>
            <TableHead>Dokumen</TableHead>
            <TableHead>Alasan</TableHead>
            <TableHead>Validator</TableHead>
            <TableHead>Tanggal</TableHead>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <Card>
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow>{getTableHeaders()}</TableRow>
          </TableHeader>
          <TableBody>
            {documents.length === 0 ? (
              <TableRow>
                <TableCell
                  colSpan={type === 'pending' ? 6 : 4}
                  className="text-center py-8 text-gray-500"
                >
                  Tidak ada dokumen
                </TableCell>
              </TableRow>
            ) : (
              documents.map(doc => (
                <DocumentValidationWorkflowTableRow
                  key={doc.id}
                  document={doc}
                  statusColors={statusColors}
                  onReview={onReview}
                  showValidator={type === 'approved'}
                  showDate={type === 'rejected'}
                />
              ))
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
